// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-Ivc9","header":"styles_header__UaTw1","travelAssignment":"styles_travelAssignment__FLBwx","card":"styles_card__YVO61"};